
import React from 'react';

export const ProductSkeleton = () => {
    return (
        <div className="flex flex-col gap-3 w-full animate-pulse">
            {/* Image Placeholder */}
            <div className="relative w-full aspect-[4/5] rounded-2xl bg-gray-200 dark:bg-white/5 overflow-hidden">
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 dark:via-white/10 to-transparent -translate-x-full animate-[shimmer_1.5s_infinite]"></div>
            </div>
            
            {/* Text Placeholders */}
            <div className="space-y-2">
                <div className="h-4 bg-gray-200 dark:bg-white/5 rounded-md w-3/4"></div>
                <div className="flex justify-between items-center">
                    <div className="h-4 bg-gray-200 dark:bg-white/5 rounded-md w-1/3"></div>
                    <div className="h-3 bg-gray-200 dark:bg-white/5 rounded-md w-1/4"></div>
                </div>
                <div className="h-3 bg-gray-200 dark:bg-white/5 rounded-md w-1/2"></div>
            </div>
        </div>
    );
};
